import {
  Button,
  Card,
  Col,
  Descriptions,
  Flex,
  Form,
  FormProps,
  InputNumber,
  Modal,
  notification,
  Popconfirm,
  Popover,
  Row,
  Space,
  TableProps,
  Tag,
} from "antd";
import { components } from "../types/OnuoGate";
import React, { ReactNode, useEffect, useState } from "react";
import apiClient from "../services/ApiClient";
import SelectLogoDevice from "./SelectLogoDevice";
import TextArea from "antd/es/input/TextArea";
import { DeleteFilled, RightOutlined } from "@ant-design/icons";
import { ProColumns, ProTable } from "@ant-design/pro-components";
import dayjs from "dayjs";

interface EditModalProps {
  isModalOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
  selectedOrderId: string | undefined;
}

export function getTableColumns(
  setShowDeviceCodeModal: (
    param: components["schemas"]["OpenOrderLine"],
  ) => void,
  deleteSaleKit: (obj: components["schemas"]["OpenOrderLine"]) => void,
  actions?: (obj: components["schemas"]["OpenOrderLine"]) => ReactNode,
  isDevMode?: boolean
) {
  const expandColumns: ProColumns<components["schemas"]["OpenOrderLine"]>[] = [
    {
      key: "deviceCode",
      title: "Handset",
    tooltip: "Virgül ile birden fazla cihaz sorgulanabilir",
        
        
      width: 100,
      dataIndex: "deviceCode",
      align: "center",
      render: (_, obj) => {
        return (
            <Popover content={obj.mainProductName}>
              {_}
            </Popover>
        )
      } 
    },
    {
      key: "ounoDeviceCode",
        tooltip: "Virgül ile birden fazla cihaz sorgulanabilir",
      title: "Ouno Device Code",
      dataIndex: "ounoDeviceCode",
      align: "center",
      render: (_, obj) => {
        if (obj.ounoDeviceCode === "") {
          return (
            <Button
              color={"red"}
              variant={"dashed"}
              onClick={() => {
                setShowDeviceCodeModal(obj || null);
              }}
            >
              Güncelle
            </Button>
          );
        }

        return <Tag color={"success"}>{obj.ounoDeviceCode}</Tag>;
      },
    },
    {
      search: false,
      key: "mainProductName",
      title: "Main Product Name",
      dataIndex: "mainProductName",
      width: 50,
      render: (_, obj) => {
        if (obj.ounoDeviceCode) {
          return (
            <>
              <Tag color={"warning"}>{obj.mainProductName}</Tag>
              <Tag icon={<RightOutlined />} color={"success"}>
                {obj.ounoDeviceName}
              </Tag>
            </>
          );
        }

        return <Tag>{obj.mainProductName}</Tag>;
      },
    },
    {
      ellipsis: true,
      key: "siparisMiktar",
      title: "Sipariş Miktarı",
      dataIndex: "siparisMiktar",
      search: false,
      width: 30,
      align: "center",
      render: (_, obj) => {
        return (
          <div>
            <Popover
              content={
                <div style={{ width: "500px" }}>
                  <Descriptions
                    items={[
                      {
                        key: "Sipariş Miktarı",
                        children: obj.siparisMiktar,
                        label: "Sipariş Miktar",
                      },
                      {
                        key: "Sevk Adedi",
                        label: "Sevk Adedi",
                        children: obj.sevkMiktar,
                      },
                      {
                        label: "Bakiye Miktar",
                        key: "Bakiye Mikter",
                        children: obj.bakiyeMiktar,
                      },
                    ]}
                  />
                </div>
              }
            >
              {obj.siparisMiktar}
            </Popover>
          </div>
        );
      },
    },

    {
      key: "logoOrderStatus",
      title: "Logo Sipariş Durumu",
      onFilter: true,
      align: "center",
      valueEnum: {
        wait: { text: "Bekleniyor", status: "wait" },
        created: { text: "Oluşturuldu", status: "created" },
        completed: { text: "Sevk Edildi", status: "completed" },
      },
      dataIndex: ["openOrderLineItem", "logoOrderStatus"],
      render: (_, obj) => {
        if (obj.openOrderLineItem) {
          if (obj.openOrderLineItem.ounoLogoInvoiceRef != null) {
            return <Tag>Sevk Edildi - {obj.openOrderLineItem.ficheNo}</Tag>;
          }

          return <Tag color={"blue"}>Olusturuldu-Irsaliye Bekleniyor</Tag>;
        }
        return <Tag color={"warning"}>Bekleniyor</Tag>;
      },
    },
    {
      minWidth: 50,
      align: 'center',
      title: "IMEI",
      dataIndex: ["openOrderLineItem", "imei"],
      order: 1,
      render: (_, obj) => {
        return <Tag>{(obj.openOrderLineItem?.imei)}</Tag>;
      },
    },

    {
      title: "VF Sipariş Tarihi",
      dataIndex: ['openOrder','orderDate'],
      order: 1,
      valueType: 'dateTimeRange',
      render: (_, obj) => {
        return <>{dayjs(obj.createdAt).toISOString()}</>;
       },
    },

    {
      title: "Satışcı",
      hideInSearch: true,
      dataIndex: ['ounoLogoUserId'],
      render: (_, obj) => {
        return <Tag>{(obj.openOrder?.ounoLogoUserCode)}</Tag>;
      },
    },

    {
      ellipsis: true,
      width: 70,
      align: 'center',
      title: "Sevkiyat Adresi",
      dataIndex: ['addressCode'],
      hideInSearch: true,

      render: (_, obj) => {
        return <Tag>{(obj.addressCode)}</Tag>;
      },
    },

    {
      ellipsis: true,
      width: 70,
      align: 'center',
      title: "Ödeme Tipi",
      hideInSearch: true,
      dataIndex: ['payPlanCode'],
      render: (_, obj) => {
        return <Tag>{(obj.payPlanCode)}</Tag>;
      },
    },

    {
      title: "Taşıyıcı Kodu",
      hideInSearch: true,
      ellipsis: true,
      width: 70,
      align: 'center',
      dataIndex: ['deliveryType'],
      order: 1,
      render: (_, obj) => {
        return <Tag>{(obj.deliveryType == 100 ? 'Kargo':'Depo')}</Tag>;
      },
    },
      
      
    {
      title: "#",
      key: "operation",
      fixed: "right",
      width: 100,
      search: false,
      render: (_, obj): ReactNode => {
        if (actions != null) {
          return actions(obj);
        }
        return (
          <>
            <Space size="middle">
              <Button
                onClick={() => {
                  setShowDeviceCodeModal(obj || null);
                  console.log(obj);
                }}
                type={"primary"}
                variant={"solid"}
              >
                Düzenle
              </Button>

              <Popconfirm
                title="Satış Kiti"
                description="Satış kiti Silinecektir"
                onConfirm={() => deleteSaleKit(obj)}
                okText="Sil"
                cancelText="İptal"
              >
                <Button
                  type={"primary"}
                  color={"red"}
                  variant={"solid"}
                  icon={<DeleteFilled />}
                >
                  Sil
                </Button>
              </Popconfirm>
            </Space>
          </>
        );
      },
    },
  ];

  if (isDevMode) {
    expandColumns.push({
      title: "itemRef",
      dataIndex: ['ounoLogicalRef']
    });
    expandColumns.push({
      title: "orderRef",
      dataIndex: ['openOrderLineItem','ounoLogoOrderLogicalRef']
    });
    
    
  }
  
  return expandColumns;
}

export default function EditModal({
  isModalOpen,
  onOk,
  onCancel,
  selectedOrderId,
}: EditModalProps) {
  const [api, contextHolder] = notification.useNotification();

  const [showChangeDeviceCodeModal, setShowDeviceCodeModal] = useState<
    components["schemas"]["OpenOrderLine"] | null
  >(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [orderData, setOrderData] = useState<
    components["schemas"]["OpenOrder"] | null
  >(null);

  const fetchOrder = async (orderId: number) => {
    setIsLoading(true);

    const response = await apiClient.getOrderDetail({ id: orderId });

    setOrderData(response.data);

    setIsLoading(false);
  };

  useEffect(() => {
    if (selectedOrderId) {
      fetchOrder(Number(selectedOrderId));
    }
  }, [selectedOrderId]);

  const [handcodeForm] = Form.useForm();

  const deleteSaleKit = async (obj: components["schemas"]["OpenOrderLine"]) => {
    const response = await apiClient
      .deleteOrderLine(obj.id || 0)
      .catch((err) => {
        return err;
      });
    console.log("wewe", response);
    if (response.status == 202) {
      api.warning({
        message: "Satış Kiti Silindi",
      });

      await fetchOrder(Number(selectedOrderId));
    }
    if (response.status == 400) {
      api.error({
        message: response.response.data,
      });
    }
  };

  const expandColumns = getTableColumns(setShowDeviceCodeModal, deleteSaleKit);

  const onFinishChangeHandcode: FormProps<
    components["schemas"]["ChangeOrderHandCodeRequest"]
  >["onFinish"] = async (values) => {
    const response = await apiClient.changeLogoHandset(
      { id: showChangeDeviceCodeModal?.id || 0 },
      values,
    );

    if (response.status == 200) {
      api.success({
        message: `Başarıyla Değiştirildi`,
        type: "success",
        duration: 3,
      });
      await fetchOrder(Number(selectedOrderId));
    }

    setShowDeviceCodeModal(null);
  };
  const onFinishChangeHandcodeFailed: FormProps<
    components["schemas"]["ChangeOrderHandCodeRequest"]
  >["onFinishFailed"] = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish: FormProps<
    components["schemas"]["SaleKitRequest"]
  >["onFinish"] = async (values) => {
    const response = await apiClient.addSaleKit(
      {
        id: Number(selectedOrderId),
      },
      values,
    );

    if (response.status == 200) {
      api.success({
        message: `Başarıyla Eklendi`,
      });
      await fetchOrder(Number(selectedOrderId));
    }
  };

  const onFinishFailed: FormProps<
    components["schemas"]["SaleKitRequest"]
  >["onFinishFailed"] = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const completeVodafoneOrder = async () => {
    const response = await apiClient
      .completeVodafoneOrder(Number(selectedOrderId))
      .catch((err) => {
        if (err.status == 400) {
          api.error({
            message: err.response.data,
          });
        }
        return err;
      });

    if (response.status == 200) {
      api.success({
        message: `Başarıyla Gönderildi`,
      });
    }
  };

  const createLogoOrder = async () => {
    const response = await apiClient
      .createLogoOrder(selectedOrderLine.map((x) => parseInt(x.toString())))
      .catch((err) => {
        if (err.status == 400) {
          api.error({
            message: err.response.data,
          });
        }
        return err;
      });

    if (response.status == 200) {
      api.success({
        message: `Başarıyla Eklendi`,
      });
      await fetchOrder(Number(selectedOrderId));
    }
  };

  const [selectedOrderLine, setSelectedOrderLine] = useState<React.Key[]>([]);

  const rowSelection: TableProps<
    components["schemas"]["OpenOrderLine"]
  >["rowSelection"] = {
    selectedRowKeys: selectedOrderLine,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedOrderLine(selectedRowKeys);
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows,
      );
    },
    getCheckboxProps: (record) => ({
      name: record.ounoDeviceName || "asd",
      disabled:
        record.openOrderLineItem?.isPlanogramProcessed ||
        record.openOrderLineItem?.ounoLogoOrderLogicalRef != null,
    }),
  };

  return (
    <>
      <Modal
        open={showChangeDeviceCodeModal != null}
        width={"1200px"}
        onOk={handcodeForm.submit}
        onCancel={() => setShowDeviceCodeModal(null)}
      >
        <Form
          form={handcodeForm}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinishChangeHandcode}
          onFinishFailed={onFinishChangeHandcodeFailed}
          autoComplete="off"
        >
          <Form.Item<components["schemas"]["SaleKitRequest"]>
            label={
              showChangeDeviceCodeModal?.deviceCode == ""
                ? "Satış Kiti"
                : "Değiştirilecek Ürün"
            }
            name="logicalRef"
            initialValue={showChangeDeviceCodeModal?.ounoLogicalRef}
            rules={[{ required: true }]}
          >
            <SelectLogoDevice />
          </Form.Item>

          {showChangeDeviceCodeModal?.deviceCode == "" && (
            <>
              <Form.Item<components["schemas"]["SaleKitRequest"]>
                initialValue={showChangeDeviceCodeModal.siparisMiktar}
                name={"orderStock"}
                label={"Adet"}
              >
                <InputNumber />
              </Form.Item>
            </>
          )}
        </Form>
      </Modal>

      <Modal
        loading={isLoading}
        width={"large"}
        title={"#" + orderData?.id + " - Edit Order"}
        open={isModalOpen}
        onOk={onOk}
        onCancel={onCancel}
      >
        <div>
          <Card style={{ marginBottom: "20px" }}>
            <Row>
              <Col span={12}>
                <Form
                  onFinish={async (
                    values: components["schemas"]["OrderEditRequest"],
                  ) => {
                    const response = await apiClient.editOrder({
                      ...values,
                      orderId: orderData?.id,
                    });
                    if (response.status == 202) {
                      api.success({
                        message: "Güncellendi",
                      });
                      await fetchOrder(Number(selectedOrderId));
                    }
                  }}
                  layout={"vertical"}
                >
                  <Form.Item<components["schemas"]["OrderEditRequest"]>
                    name={"description"}
                    label={"Vodafone Açıklama"}
                    initialValue={orderData?.description}
                    help={"Değiştirilemez bilgi için"}
                  >
                    <TextArea readOnly />
                  </Form.Item>
                  <Form.Item<components["schemas"]["OrderEditRequest"]>
                    name={"ounoDescription"}
                    label={"Ouno Açıklama"}
                    initialValue={orderData?.ounoDescription}
                  >
                    <TextArea />
                  </Form.Item>
                  <Form.Item label={null}>
                    <Button type="primary" htmlType="submit">
                      Güncelle
                    </Button>
                  </Form.Item>
                </Form>
              </Col>
              <Col span={12}>
                <Flex justify={"end"} gap={"small"}>
                  <Space>
                    <Popconfirm
                      title="Logo Sipariş Oluşturulacak"
                      description="Emin misiniz?"
                      onConfirm={createLogoOrder}
                      okText="Oluştur"
                      //disabled={orderData?.ounoLogoOrderLogicalRef != undefined && orderData?.ounoLogoOrderLogicalRef > 0}
                      cancelText="İptal"
                    >
                      <Button
                        //disabled={orderData?.ounoLogoOrderLogicalRef != undefined && orderData?.ounoLogoOrderLogicalRef > 0}
                        type="primary"
                      >
                        Logo Siparişi Oluştur
                      </Button>
                    </Popconfirm>

                    <Popconfirm
                      title="Logo Sipariş Oluşturulacak"
                      description="Emin misiniz?"
                      onConfirm={completeVodafoneOrder}
                      okText="Oluştur"
                      cancelText="İptal"
                    >
                      <Button type="primary" color={"red"} variant={"solid"}>
                        Vodafone'a Gönder
                      </Button>
                    </Popconfirm>
                  </Space>
                </Flex>
              </Col>
            </Row>
          </Card>

          <ProTable<components["schemas"]["OpenOrderLine"]>
            rowSelection={rowSelection}
            columns={expandColumns}
            search={false}
            dataSource={orderData?.openOrderLines || []}
            pagination={false}
            rowKey={(obj) => obj.id?.toString() || "0"}
          />

          <Row style={{ marginTop: "10px" }}>
            <Col span={16}>
              <Form
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 900 }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item<components["schemas"]["SaleKitRequest"]>
                  label="Satış Kiti"
                  name="logicalRef"
                  rules={[{ required: true }]}
                >
                  <SelectLogoDevice />
                </Form.Item>

                <Form.Item<components["schemas"]["SaleKitRequest"]>
                  label={"Adet"}
                  name={"orderStock"}
                  rules={[{ required: true }]}
                >
                  <InputNumber />
                </Form.Item>

                <Form.Item label={null}>
                  <Button type="primary" htmlType="submit">
                    Satış Kiti Ekle
                  </Button>
                </Form.Item>
              </Form>
            </Col>
            {/* <Col span={8} offset={16} style={{textAlign: 'right'}}>
                            <Button color={'primary'} variant={'solid'}>Satış Kiti Ekle</Button>
                        </Col>*/}
          </Row>
        </div>
      </Modal>

      {contextHolder}
    </>
  );
}
